import {
	CLEAR_STATS_CHECKPOINTS,
	FETCH_STATS_CHECKPOINT_BEGIN,
	FETCH_STATS_CHECKPOINT_SUCCESS,
	FETCH_STATS_CHECKPOINT_FAILURE,
	SET_MANUAL_COUNTS
} from "./actions";
import moment from "moment";
import StatsCheckpoint from "models/statsCheckpoint";

export const initialState = {
	statsCheckpoints: null,
	statsToReload: null,
	manualCounts: {},
	isLoading: false
};

/**
 * Reducer managing Checkpoint statistic .
 *
 * @name StatsCheckpointReducer
 *
 * @param {Object} state - Current application state
 * @param {AbstractAction} action - Action to dispatch
 * @return {Object} new state
 */
export default (state = initialState, action) => {
	switch (action.type) {
		case FETCH_STATS_CHECKPOINT_BEGIN:
		case FETCH_STATS_CHECKPOINT_FAILURE:
			return {
				...state,
				isLoading: action.isLoading
			};

		// Listenning the action to getOneCheckpoint and retrieve his stats
		case "Checkpoints/GetOne/Success": {
			// We retrieve the checkpoint data
			const checkpoint = action.payload() ? action.payload().data : null;

			// We prevent that we have one checkpoint before manipulate data
			if (!checkpoint || !state.manualCounts[checkpoint.id]) {
				return state;
			}

			const checkpointId = checkpoint.id;
			const checkpointCounts = Object.assign(
				{},
				state.manualCounts[checkpointId]
			);

			// For increment/decrement, we remove the data inserted
			// inside the manualCounts if the stats update is after the
			// date inside inc/dec.
			checkpointCounts.increment = checkpointCounts.increment.filter(
				date => moment(date).isAfter(checkpoint.stats.last_update)
			);

			checkpointCounts.decrement = checkpointCounts.decrement.filter(
				date => moment(date).isAfter(checkpoint.stats.last_update)
			);

			return {
				...state,
				manualCounts: {
					...state.manualCounts,
					[checkpointId]: checkpointCounts
				}
			};
		}

		case FETCH_STATS_CHECKPOINT_SUCCESS: {
			const data = action.payload;
			const newManualCounts = { ...state.manualCounts };

			let statsCheckpoints = { ...state.statsCheckpoints } || {};
			let newStats = data.map(datum => new StatsCheckpoint(datum));

			newStats.forEach(statCkpt => {
				let checkpointCounts = newManualCounts[statCkpt.checkpointId()];

				// For increment/decrement
				if (checkpointCounts) {
					checkpointCounts.increment = checkpointCounts.increment.filter(
						date => moment(date).isAfter(statCkpt.getLastUpdate())
					);

					checkpointCounts.decrement = checkpointCounts.decrement.filter(
						date => moment(date).isAfter(statCkpt.getLastUpdate())
					);
				}

				statsCheckpoints[statCkpt.checkpointId()] = statCkpt;
			});

			// Expired stats need to be reload faster than others
			const statsToReload = [];
			Object.keys(statsCheckpoints).forEach(checkpointId => {
				if (statsCheckpoints[checkpointId].expiredData()) {
					statsToReload.push(checkpointId);
				}
			});

			return {
				...state,
				statsCheckpoints,
				statsToReload,
				isLoading: action.isLoading,
				manualCounts: newManualCounts
			};
		}

		case SET_MANUAL_COUNTS: {
			const newManualCounts = { ...state.manualCounts };
			const isIncrement = action.increment;

			if (!newManualCounts[action.id]) {
				newManualCounts[action.id] = {
					decrement: [],
					increment: []
				};
			}

			newManualCounts[action.id][
				isIncrement ? "increment" : "decrement"
			].push(new Date().toUTCString());

			return {
				...state,
				manualCounts: newManualCounts
			};
		}
		case CLEAR_STATS_CHECKPOINTS:
			return initialState;
		default:
			return state;
	}
};
